const audioCache = {};

export const Utils = {
    methods: {
        getLogo() {
            return `/static/logo.png`;
        },
        initAndUnlockAudio(sound) {
            if (audioCache[sound]) return;
            const audio = new Audio(`/static/sounds/${sound}`);
            audio.play().catch(() => {});
            audio.pause();
            audio.currentTime = 0;
            audioCache[sound] = audio;
        },
        playSound(name, loop) {
            const audio = audioCache[name];
            if (!audio) {
                console.warn(`Sound ${name} not found in cache.`);
                return null;
            }
            audio.volume = 0.9;
            if (loop) audio.loop = true;
            audio.currentTime = 0;
            audio.play().catch(e => console.warn("Audio blocked:", e));
            return audio;
        },
        stopSound(audio) {
            if (!audio) return;
            audio.loop = false;
            audio.pause();
        },
        addZero(i) {
            if (i < 10) i = "0" + i;
            return i;
        },
        convertToCSV(objArray) {
            const array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
            let str = '';
            for (let i = 0; i < array.length; i++) {
                let line = '';
                for (let index in array[i]) {
                    if (line != '') line += ','
                    line += array[i][index];
                }
                str += line + '\r\n';
            }
            return str;
        },
        exportCSVFile(headers, items, fileTitle) {
            if (headers) items.unshift(headers);
            const jsonObject = JSON.stringify(items);
            const csv = this.convertToCSV(jsonObject);
            const exportedFilenmae = fileTitle + '.csv' || 'export.csv';
            const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
            if (navigator.msSaveBlob) {
                navigator.msSaveBlob(blob, exportedFilenmae);
            } else {
                const link = document.createElement('a');
                if (link.download !== undefined) {
                    const url = URL.createObjectURL(blob);
                    link.setAttribute('href', url);
                    link.setAttribute('download', exportedFilenmae);
                    link.style.visibility = 'hidden';
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                }
            }
        },
    },
};



// WEBPACK FOOTER //
// ./src/mixins/Utils.js